var e=5e3,t="https://unpkg.com/@ffmpeg/core-st@0.11.1/dist/ffmpeg-core.js",o="silenceremove=start_periods=1:stop_periods=-1:start_threshold=-30dB:stop_threshold=-30dB:start_silence=2:stop_silence=2",s="https://api.openai.com/v1/audio/";

export { e as a, t as b, o as c, s as d };
